import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import PaymentSuccess from './paymentSuccess';
import PaymentFailure from './paymentFailure';
import reportWebVitals from './reportWebVitals';
import Cookies from './Cookies';
import TermsOfService from './TermsOfService';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="paymentSuccess" element={<PaymentSuccess />} />
      <Route path="paymentFailure" element={<PaymentFailure />} />
      <Route path="cookies" element={<Cookies />} />
      <Route path="terms-of-service" element={<TermsOfService />} />
    </Routes>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
